import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Button, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { createEmployee, deleteEmployee, getAllEmployee, getEmployee, updateEmployee } from "../../redux/actions/staticData";
import { uploadImage } from "../../redux/actions/addCampaigndata";
import FullScreenStatic from "../../components/Comman/dialogStatic/Dialog-box";
import YupValidationTeam from "./comman/yupvalidationTema";
import EmployeeModal from "./comman/TeamViewModal";
import AddIcon from "@mui/icons-material/Add";
import CardWithButton from "../../components/Comman/button-new";




export default function CreateAiTable(props) {
  const [agentCreationModelOpen, setAgentCreationModelOpen] = React.useState(false);
  const [updatingAgent, setUpdatingAgent] = React.useState(false);
  const [updatingAgentId, setUpdatingAgentId] = React.useState("");
  const [viewModalOpen, setViewModalOpen] = React.useState(false);
  const dispatch = useDispatch();


  const singleEmployee = useSelector(
    (state) => state?.employeeReducer?.employee
  );

  const { employeeData } = useSelector((state) => ({
    employeeData: state?.employeeReducer?.employees
  }));



  React.useEffect(() => {
    dispatch(getAllEmployee())
  }, [dispatch])

  const { control, handleSubmit,
    formState: { errors },
    setValue,
    register,
    watch,
    clearErrors,
    setError
  } = useForm({
    resolver: yupResolver(YupValidationTeam),
    defaultValues: {
      role: "",
      name: "",
      social_link: "",
      social_icon: "https://storage.googleapis.com/plutos-dev-images/cbms/campaign/image-1737970920688-linkedin.png",
      img_src: "",
      type: "",
      employee_id: "",
      order: null
    },
  });

  function handleEditClick(id) {
    setAgentCreationModelOpen(true);
    dispatch(getEmployee(id)).then((singleEmployee) => {
      setValue("type", singleEmployee?.type);
      setValue("name", singleEmployee?.name);
      setValue("role", singleEmployee?.role);
      setValue("img_src", singleEmployee?.img_src);
      setValue("social_icon", singleEmployee?.social_icon);
      setValue("social_link", singleEmployee?.social_link);
      setValue("employee_id", singleEmployee?.employee_id);
      setValue("order", singleEmployee?.order)
    })
    setUpdatingAgentId(id)
    setUpdatingAgent(true)
  }

  // console.log(updatingAgentId,"updatingAgentId")
  const onFormSubmit = async (data) => {
    const { order, ...newData } = data;

    let newPayload = {
      ...newData,
      'order': parseInt(data?.order)
    }
    if (updatingAgentId) {
      dispatch(updateEmployee(updatingAgentId, newPayload));
    } else {
      dispatch(createEmployee(newPayload));
    }
    setAgentCreationModelOpen(false);
    setUpdatingAgent(false);
    setUpdatingAgentId("");
    setValue("type", "");
    setValue("name", "");
    setValue("role", "");
    setValue("img_src", "");
    setValue("social_link", "");
    setValue("employee_id", "");
    setValue("order", "");
  };

  const handleTeamDelete = (id) => {
    dispatch(deleteEmployee(id));
  }

  const handleViewTeam = (id) => {
    setViewModalOpen(!viewModalOpen);

    if (!viewModalOpen) {
      dispatch(getEmployee(id));
    }
  }


  const columns = [
    {
      field: "employee_id",
      headerName: "ID",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: "Name",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "type",
      headerName: "Type",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "social_icon",
      headerName: "Social Icon",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <img src={params?.row.img_src} alt="Img" style={{ width: 50, height: 50, borderRadius: "12px", objectFit: "contain", }} />
        </>
      ),
    },
    {
      field: "social_link",
      headerName: "Social Link",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <div>
            <IconButton onClick={() => handleViewTeam(params.row.id)} color="primary" title="View">
              <VisibilityIcon />
            </IconButton>
            <IconButton onClick={() => handleEditClick(params.row.id)} color="info" title="Edit">
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => handleTeamDelete(params.row.id)} color="error" title="Delete">
              <DeleteIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleImageFunc = (logo, e) => {
    e.preventDefault();
    const file = e.target.files[0];
    const isImage = file && file.type.startsWith("image/");
    const formData = new FormData();
    formData.append('image', file);

    if (logo) {
      clearErrors(logo);
    }
    if (!isImage) {
      setError(logo, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }
    // Dispatch the file to the server for upload
    dispatch(uploadImage(formData)).then((res) => {
      if (res) {
        setValue(logo, res);
      }
    }).catch(error => {
      console.error("Image upload failed", error);
    });
  };

  const handleDialog = () => {
    setAgentCreationModelOpen(!agentCreationModelOpen);
    setUpdatingAgent(false);
    setValue("type", "");
    setValue("name", "");
    setValue("role", "");
    setValue("img_src", "");
    // setValue("social_icon", "");
    setValue("social_link", "");
    setValue("employee_id", "");
    setValue("order", "");
  }


  const handleType = (value) => {
    setValue("type", value.target.value)
  }


  const handleAddMore = () => {
    setAgentCreationModelOpen(!agentCreationModelOpen);
    onFormSubmit();
  }





  return (
    <>
      <Box sx={{ height: 380, width: "100%" }} style={{ margin: "0px 0px 40px 0px" }}>
        <CardWithButton
          title="Add Your Employee Here"
          className=""
          buttonLabel="Create Employee"
          buttonIcon={<AddIcon />}
          buttonClick={handleDialog}
        />
        {
          employeeData ?
            <Box sx={{ height: 500, width: "98%", backgroundColor: "#fff", borderRadius: "10px", padding: "10px",marginTop: "30px" }}>
              <DataGrid
                rows={Array.isArray(employeeData) ? employeeData : [employeeData]}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
                disableDensitySelector
                sx={{ "& .MuiDataGrid-columnSeparator": { display: "none", }, "& .MuiDataGrid-cell": {}, }} />
            </Box>
            : ""
        }
      </Box>

      {agentCreationModelOpen ?
        <FullScreenStatic
          handleDialog={handleDialog}
          agentCreationModelOpen={agentCreationModelOpen}
          handleImageFunc={handleImageFunc}
          onFormSubmit={onFormSubmit}
          control={control} errors={errors}
          register={register}
          clearErrors={clearErrors}
          updatingAgent={updatingAgent}
          watch={watch}
          handleSubmit={handleSubmit}
          setError={setError}
          handleType={handleType}
          handleAddMore={handleAddMore}
        /> : ""}

      {/* view ai Employee by id */}
      {
        viewModalOpen ? <EmployeeModal onClose={handleViewTeam} open={viewModalOpen} employee={singleEmployee} /> : ""
      }
    </>
  );
}
